/**
 * @file 博士会横向滚动页面
 * @author  rentao(v-rentao@baidu.com)
 */ 
 import React, {useCallback, useRef, useState} from 'react';
 import A from '../../../../components/a/A'
 import VerticalEllipsis from '../../../../components/vertical-ellipsis/VerticalEllipsis';
import {IPictureTextCardItem} from './types'
import './style.less'
 const IntersetBanner: React.FC <IPictureTextCardItem> = props =>{
   const [textHeight, setTextHeight] = useState<string | number | undefined>();
   const textInnerRef = useRef<HTMLDivElement>(null);
   const {
      title,
      text,
      img,
      signingUp,
      btnLink,
      btnText
  } = props;
  const onMouseEnter = useCallback(() => {
   if (textInnerRef.current?.parentElement) {
       const parent = textInnerRef.current.parentElement;
       if (parent.offsetHeight < textInnerRef.current.offsetHeight) {
           setTextHeight(textInnerRef.current.offsetHeight);
       }
   }
}, []);

const onMouseLeave = useCallback(() => {
   setTextHeight(undefined);
}, []);

     return (
        <div
        className="paddle-ppdeng-card-grid"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave} 
        >
           <div className="paddle-ppdeng-card">
              <A 
                 className="paddle-ppdeng-card-full-link"
                 href={btnLink}
                 target
               >
                  <div 
                    className="paddle-ppdeng-card-img"
                    style={{backgroundImage: img ? `url(${img})` : undefined}}
                  >
                     <img src="{img}" alt="{title}"/>
                  </div>
                  <div className="paddle-ppdeng-card-contain">
                        <div className="paddle-ppdeng-card-title">
                            {title}
                        </div>
                        <div className="paddle-ppdeng-card-extra">
                            {signingUp
                            && (
                                <span className="paddle-ppdeng-card-extra-tag">报名中</span>
                            )}
                        </div>
                        <div className="paddle-ppdeng-card-text">
                            <VerticalEllipsis
                                className="paddle-ppdeng-card-text-inner"
                                style={{
                                    height: textHeight
                                }}
                                innerRef={textInnerRef}
                                delay={200}
                            >
                                {text}
                            </VerticalEllipsis>
                        </div>
                        <div className="paddle-ppdeng-card-tag-group">
                            <span className="paddle-ppdeng-card-tag">
                                {btnText} {'>'}
                            </span>
                        </div>
                     </div>
              </A>
           </div>
           
        </div>
     )
   
     }
 export default IntersetBanner